<div class="getting-started">
  <!-- <app-get-in-touch></app-get-in-touch> -->
  <div class="getting-started__banner">
    <div class="main-container">
      <div class="banner__header">
        <img
          class="logo"
          src="../../../../../../assets/images/kunnect-logo.svg"
          alt="" />
        <div class="banner__header--col">
          <!-- <div class="user-profile mr-8">
            <span class="material-icons"> account_circle </span>
            <div>
              <span>{{ firstName }} {{ lastName }}</span>
              <small> {{ lastSession }}</small>
            </div>
          </div> -->
          <span
            class="sign-off"
            (click)="signOut()"
            (keyup)="signOut()"
            tabindex="-1">
            <span class="material-icons mr-1"> logout </span>Sign In
          </span>
        </div>
      </div>
      <div class="banner__content">
        <h2>Welcome to iKunnect</h2>
        <p>
          iKunnect is your comprehensive Amazon cloud-based solution for all
          your Contact Center and telecommunications needs, available anywhere
          in the world. Our platform supports simplified omni-channel
          communications, ensuring seamless integration across all customer
          touch points for agents in the office or working from home.
        </p>
      </div>
      <div class="banner__bottom">
        <div fxLayout="row" fxLayoutGap="20px">
          <div fxFlex="50">
            <div class="banner__bottom__card">
              <h6>Getting Started?</h6>
              <p>
                Getting started with iKunnect is easy! Watch the video for
                simple steps to quickly set up your iKunnect contact center.
              </p>
              <button class="primary-btn link" (click)="toggleVideoPopup()">
                Click Here
              </button>
            </div>
          </div>
          <div fxFlex="50">
            <div class="banner__bottom__card">
              <h6>Getting Help from an Expert</h6>
              <p>
                Need assistance with your iKunnect set up? Our experts are here
                to help! Visit the iKunnect customer portal to request
                personalized support and ensure your system is configured to
                meet your needs.
                <span
                  (click)="openSupportDailog()"
                  (keyup)="openSupportDailog()"
                  tabindex="-1"
                  >iKunnect customer portal</span
                >. For general inquiries about the usage of this tool, please
                fill out the Contact form.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="get-ready">
    <div class="main-container">
      <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
        <div fxFlex="50">
          <div class="get-ready__img">
            <img
              src="../../../../../assets/images/getting-started.svg"
              alt="" />
          </div>
        </div>
        <div fxFlex="50">
          <div class="get-ready__cont">
            <h4>Ready to get started?</h4>
            <p class="mb-7">Lets setup the system.</p>
            <button class="primary-btn" (click)="goToLogin()">
              Click Here
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="help-topics">
    <div class="main-container">
      <div class="help-topics__header">
        <h4>HELP BY TOPICS</h4>
        <p>
          Need help with a specific topic? Choose one of the options below to
          learn more.
        </p>
      </div>
      <div class="help-topics__row">
        <div class="help-topics__col">
          <img src="../../../../../assets/images/icons/intro-icon.svg" alt="" />
          <div class="ml-2 pr-4">
            <h6>Introduction</h6>
            <p class="ellipsis-2">
              iKunnect is a powerful cloud-based contact center solution
              designed to optimize inbound and outbound communications.
            </p>
            <button
              class="primary-btn link pa-0 mt-1"
              (click)="goToHelpTopics(0)">
              Learn More
            </button>
          </div>
        </div>
        <div class="help-topics__col">
          <img
            src="../../../../../assets/images/icons/getting-started.svg"
            alt="" />
          <div class="ml-2 pr-4">
            <h6>Getting Started</h6>
            <p class="ellipsis-2">
              Before using iKunnect effectively, you need to set up your
              account, configure system settings, and understand the dashboard.
            </p>
            <button
              class="primary-btn link pa-0 mt-1"
              (click)="goToHelpTopics(1)">
              Learn More
            </button>
          </div>
        </div>
        <div class="help-topics__col">
          <img
            src="../../../../../assets/images/icons/core-features.svg"
            alt="" />
          <div class="ml-2">
            <h6>Core Features</h6>
            <p class="ellipsis-2">
              iKunnect provides a robust set of tools to manage omnichannel
              customer interactions, track tickets, and handle calls
              efficiently.
            </p>
            <button
              class="primary-btn link pa-0 mt-1"
              (click)="goToHelpTopics(2)">
              Learn More
            </button>
          </div>
        </div>
        <div class="help-topics__col">
          <img src="../../../../../assets/images/icons/telephone.svg" alt="" />
          <div class="ml-2 pr-4">
            <h6>Telephony & Communication</h6>
            <p class="ellipsis-2">
              iKunnect integrates telephony features that enhance agent
              performance, ensure compliance, and improve customer connections
              through voicemail,
            </p>
            <button
              class="primary-btn link pa-0 mt-1"
              (click)="goToHelpTopics(3)">
              Learn More
            </button>
          </div>
        </div>

        <div class="help-topics__col">
          <img src="../../../../../assets/images/icons/call.svg" alt="" />
          <div class="ml-2 pr-4">
            <h6>Advanced Call Features</h6>
            <p class="ellipsis-2">
              Beyond basic call handling, iKunnect offers advanced features like
              intelligent call routing and IVR, allowing businesses to enhance
              efficiency and customer satisfaction.
            </p>
            <button
              class="primary-btn link pa-0 mt-1"
              (click)="goToHelpTopics(4)">
              Learn More
            </button>
          </div>
        </div>

        <div class="help-topics__col">
          <img src="../../../../../assets/images/icons/settings.svg" alt="" />
          <div class="ml-2 pr-4">
            <h6>Productivity Enhancements</h6>
            <p class="ellipsis-2">
              iKunnect includes tools that help agents work more efficiently by
              automating repetitive tasks, organizing workflows, and improving
              response times.
            </p>
            <button
              class="primary-btn link pa-0 mt-1"
              (click)="goToHelpTopics(5)">
              Learn More
            </button>
          </div>
        </div>
        <div class="help-topics__col">
          <img src="../../../../../assets/images/icons/automation.svg" alt="" />
          <div class="ml-2 pr-4">
            <h6>Automation & AI</h6>
            <p class="ellipsis-2">
              iKunnect incorporates automation to streamline processes, reduce
              manual workloads, and improve customer experience.
            </p>
            <button
              class="primary-btn link pa-0 mt-1"
              (click)="goToHelpTopics(6)">
              Learn More
            </button>
          </div>
        </div>

        <div class="help-topics__col">
          <img src="../../../../../assets/images/icons/analytics.svg" alt="" />
          <div class="ml-2 pr-4">
            <h6>Analytics & Reporting</h6>
            <p class="ellipsis-2">
              iKunnect provides in-depth analytics and reporting tools to track
              performance, customer interactions, and ticket resolution
              efficiency. These insights help businesses make data-driven
              decisions.
            </p>
            <button
              class="primary-btn link pa-0 mt-1"
              (click)="goToHelpTopics(7)">
              Learn More
            </button>
          </div>
        </div>
        <div class="help-topics__col">
          <img
            src="../../../../../assets/images/icons/integrations.svg"
            alt="" />
          <div class="ml-2 pr-4">
            <h6>Integrations</h6>
            <p class="ellipsis-2">
              iKunnect connects with other business tools, including ticketing
              systems and CRMs, to enable seamless data sharing and workflow
              automation.
            </p>
            <button
              class="primary-btn link pa-0 mt-1"
              (click)="goToHelpTopics(8)">
              Learn More
            </button>
          </div>
        </div>
        <div class="help-topics__col">
          <img src="../../../../../assets/images/icons/mobile-tab.svg" alt="" />
          <div class="ml-2 pr-4">
            <h6>Mobile & Tablet Support</h6>
            <p class="ellipsis-2">
              iKunnect offers mobile compatibility to help agents and managers
              stay connected on the go. While full mobile functionality is still
              evolving, users can already manage certain tasks from tablets.
            </p>
            <button
              class="primary-btn link pa-0 mt-1"
              (click)="goToHelpTopics(9)">
              Learn More
            </button>
          </div>
        </div>
        <div class="help-topics__col">
          <img
            src="../../../../../assets/images/icons/troubleshooting.svg"
            alt="" />
          <div class="ml-2 pr-4">
            <h6>Troubleshooting & Support</h6>
            <p class="ellipsis-2">
              This section provides solutions to common issues, details on how
              to contact support, and information about iKunnect’s ongoing
              feature updates.
            </p>
            <button
              class="primary-btn link pa-0 mt-1"
              (click)="goToHelpTopics(10)">
              Learn More
            </button>
          </div>
        </div>
        <div class="help-topics__col">
          <img src="../../../../../assets/images/icons/appendices.svg" alt="" />
          <div class="ml-2 pr-4">
            <h6>Appendices</h6>
            <p class="ellipsis-2">
              A reference section for users needing definitions of key terms and
              an overview of upcoming iKunnect enhancements.
            </p>
            <button
              class="primary-btn link pa-0 mt-1"
              (click)="goToHelpTopics(11)">
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="contact-support">
    <div class="main-container">
      <div fxLayout="row">
        <div fxFlex="60">
          <h2>Contact our support <span class="d-block">team</span></h2>
          <p class="ellipsis-2">
            For general inquiries about the usage of this tool, please fill out
            <span class="d-block">the Contact form.</span>
          </p>
          <button (click)="openSupportDailog()" class="primary-btn">
            Click Here
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="kunnect-footer">
    <div class="main-container">
      <div fxLayout="row" fxLayoutGap="40px">
        <div fxFlex="30">
          <div class="pr-3">
            <img
              class="logo"
              src="../../../../../../assets/images/kunnect-logo.svg"
              alt="" />
            <p>
              iKunnect is the best Hosted Contact Center Software available
              today. We provide an Amazon cloud based solution that covers all
              your Contact Center software and telecommunications needs anywhere
              on the globe.
            </p>
          </div>
        </div>
        <div fxFlex="20">
          <div class="kunnect-footer__cont">
            <h6>Solutions</h6>
            <div class="kunnect-footer__links">
              <span>
                <button mat-button class="primary-btn-link">
                  Outbound Contact Center
                </button>
              </span>
              <span>
                <button mat-button class="primary-btn-link">
                  Inbound Contact Center
                </button>
              </span>

              <span>
                <button mat-button class="primary-btn-link">Back Office</button>
              </span>
              <span>
                <button mat-button class="primary-btn-link">
                  Managing Performance
                </button>
              </span>
            </div>
            <h6 class="mt-3">Discover the Cloud</h6>
          </div>
        </div>
        <div fxFlex="20">
          <div class="kunnect-footer__cont">
            <h6>Services</h6>
            <div class="kunnect-footer__links">
              <span>
                <button mat-button class="primary-btn-link">
                  24/7/365 Customer Service
                </button>
              </span>
              <span>
                <button mat-button class="primary-btn-link">
                  Third Party Integration
                </button>
              </span>
              <h6 class="mt-7">Working With Us</h6>
              <span>
                <button mat-button class="primary-btn-link">
                  About iKunnect
                </button>
              </span>
              <span>
                <button mat-button class="primary-btn-link">Partners</button>
              </span>
            </div>
          </div>
        </div>
        <div fxFlex="20">
          <div class="kunnect-footer__cont">
            <h6>Pricing</h6>
            <h6 class="mt-2">Planning Tools</h6>
            <h6 class="mt-2">Contact</h6>
            <h6 class="mt-2">Register</h6>
          </div>
        </div>
      </div>
      <hr />
      <div fxLayout="row" fxLayoutGap="40px">
        <div fxFlex="30">
          <div class="kunnect-footer__cont">
            <h6>News & Resources</h6>
            <div class="kunnect-footer__links">
              <span>
                <button mat-button class="primary-btn-link">
                  iKunnect in the News
                </button>
              </span>
              <span>
                <button mat-button class="primary-btn-link">
                  Glossary & Research
                </button>
              </span>

              <span>
                <button mat-button class="primary-btn-link">
                  Case Studies
                </button>
              </span>
            </div>
          </div>
        </div>

        <div fxFlex="20">
          <div class="kunnect-footer__cont">
            <h6>The Legal Bit</h6>
            <div class="kunnect-footer__links">
              <span>
                <button
                  mat-button
                  class="primary-btn-link"
                  (click)="gotoPrivacy()">
                  Privacy Statement
                </button>
              </span>
              <span>
                <button
                  mat-button
                  class="primary-btn-link"
                  (click)="gotoTerms()">
                  Terms & Conditions
                </button>
              </span>

              <span>
                <button mat-button class="primary-btn-link">Sitemap</button>
              </span>
              <span>
                <button mat-button class="primary-btn-link">
                  Security Policy
                </button>
              </span>
            </div>
          </div>
        </div>
        <div fxFlex="20">
          <div class="kunnect-footer__cont">
            <h6>Get in Touch</h6>
            <div class="kunnect-footer__links">
              <span class="mt-2"> info&#64;kunnect.com </span>
              <span class="mt-2"> 877.586.6328 </span>
              <span class="mt-2"> 1.954.271.1329 </span>
              <span class="mt-2"> Ft. Lauderdale, FL </span>
            </div>
          </div>
        </div>
        <div fxFlex="20">
          <div class="kunnect-footer__cont">
            <h6>Follow Us</h6>
            <div class="social-icons">
              <a href="#">
                <img
                  src="../../../../../../assets/images/icons/linkedin-icon.svg"
                  alt="" />
              </a>
              <a href="#">
                <img
                  src="../../../../../../assets/images/icons/twitter-icon.svg"
                  alt="" />
              </a>
              <a href="https://www.facebook.com/invictusbpo/" target="_blank">
                <img
                  src="../../../../../../assets/images/icons/facebook-icon.svg"
                  alt="" />
              </a>
              <a href="#">
                <img
                  src="../../../../../../assets/images/icons/instagram-icon.svg"
                  alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <p>© iKunnect Inc.2024. All Rights Reserved</p>
      </div>
    </div>
  </div>
  <div class="video-popup" *ngIf="videoPopup">
    <div class="video-popup__cont">
      <button class="primary-btn link" (click)="toggleVideoPopup()">
        <span class="material-icons mr-1"> close </span>
        Close
      </button>

      <h5>Product Demo video Coming Soon ...</h5>
    </div>
  </div>

  <!-- popup Html -->
  <div class="overview-popup" *ngIf="overviewPopup">
    <div class="overview-popup__cont">
      <div class="overview-popup__header">
        <!-- <button
          *ngIf="!viewAllBtn"
          class="view-all"
          (click)="viewAllFeatures()">
          View All
        </button> -->
        <button class="close-btn" (click)="closeOverviewPopup()">
          <span class="material-icons"> close </span> Close
        </button>
      </div>
      <div class="overview-popup__body">
        <div class="feature-block">
          <div class="feature-block__left">
            <div
              *ngFor="let feature of featureList.slice(0, 5); let i = index"
              [class]="feature.className"
              [class.show]="features[feature.key]"
              [style.animationDelay]="i * 1 + 's'">
              <div class="feature-col__head">
                <h6>{{ feature.label }}</h6>
                <span>{{ feature.id }}</span>
              </div>
              <p>{{ feature.cont }}</p>
            </div>
          </div>
          <div class="feature-block__center">
            <div class="ik-logo__block">
              <div class="ik-logo">
                <img src="../../../../../../assets/images/ik.svg" alt="" />
              </div>
              <div class="icons-block">
                <!-- <button
                  *ngFor="let item of featureIcons"
                  [class]="item.class"
                  (click)="toggleFeature(item.feature)">
                  <span class="material-icons-outlined"> {{ item.icon }} </span>
                </button> -->
                <button *ngFor="let item of featureIcons" [class]="item.class">
                  <span class="material-icons-outlined"> {{ item.icon }} </span>
                </button>
              </div>
            </div>
          </div>
          <div class="feature-block__right">
            <div
              *ngFor="let feature of featureList.slice(5); let i = index"
              [class]="feature.className"
              [class.show]="features[feature.key]"
              [style.animationDelay]="5 + i * 1 + 's'">
              <div class="feature-col__head">
                <h6>{{ feature.label }}</h6>
                <span>{{ feature.id }}</span>
              </div>
              <p>{{ feature.cont }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="overview-popup__img">
      <button class="btn-close" (click)="closeOverviewPopup()">
        <span class="material-icons"> close </span> Close
      </button>
      <img src="../../../../../../assets/images/ikunnect-overview.png" alt="" />
    </div> -->
    <div
      tabindex="0"
      class="overview-popup__overlay"
      (click)="closeOverviewPopup()"
      (keydown.enter)="closeOverviewPopup()"></div>
  </div>
  <!-- popup end -->
</div>
